import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const ReturnsAndRefunds = () => {
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <div className='py-2 font-poppins  p-2'>
            <h2 className="text-xl md:text-2xl text-bnd-1 font-poppins font-semibold">{translate ? 'Return & Refund Policy' : 'রিটার্ন ও রিফান্ড পলিসি'} </h2>
            <hr className="bg-bnd-2 w-48 h-1 rounded-lg" />
            <h3 className="text-xl text-gray-900 font-poppins py-3 font-bold">{translate ? 'Refund Policy:' : 'রিফান্ড পলিসিঃ'}</h3>


            <div>
                <p className="mb-3">
                    {translate ?
                        "After receiving the product, in case of product problems (such as: product broken , torn , wrong product , product not working , product does not match the image , etc.) you can get a full refund of the purchased product subject to the following conditions."
                        :
                        "প্রোডাক্ট গ্রহনের পর প্রোডাক্টের সমস্যার (যেমন : প্রোডাক্ট ভাঙ্গা, ছেঁড়া, ভুল পণ্য , প্রোডাক্ট কাজ না করা, ছবির সাথে প্রোডাক্টের মিল না থাকা ইত্যাদি) ক্ষেত্রে আপনি ক্রয়কৃত প্রোডাক্টটির সম্পূর্ণ মূল্য নিচের শর্ত সাপেক্ষে ফেরত পেতে পারেন।"
                    }
                </p>

                <ul className=''>
                    <ol className="p-4">
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                                {translate ? '1' : '১'}
                            </span>

                            {
                                translate ? "After receipt of delivery max  48  within hours to complain@deerparfum.com Email to."
                                    :
                                    "ডেলিভারি গ্রহনের পর সর্বোচ্চ ৪৮ ঘণ্টার মধ্যে আপনাকে complain@deerparfum.com এ মেইল করতে হবে ।"
                            }
                        </li>
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>

                                {translate ? '2' : '২'}
                            </span>
                            {translate ?
                                "The product must be unused ,  intact  And be without any errors. If a product is returned to us in inadequate condition ,  We reserve the right to return it to you."
                                :
                                "পণ্যটি অবশ্যই অব্যবহৃত, অক্ষত এবং কোনো ত্রুটি ছাড়াই হতে হবে। যদি একটি পণ্য আমাদের কাছে অপর্যাপ্ত অবস্থায় ফেরত দেওয়া হয়, আমরা তা আপনার কাছে ফেরত পাঠানোর অধিকার রাখি।"
                            }
                        </li>
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                                {translate ? '3' : '৩'}
                            </span>
                            {translate ?
                                "Product must have original tag ,  Should include user manual , free accessories and accessories."
                                :
                                "পণ্যটিতে অবশ্যই অরিজিনাল ট্যাগ, ব্যবহারকারীর ম্যানুয়াল, ফ্রি জিনিসপত্র এবং আনুষাঙ্গিকগুলো অন্তর্ভুক্ত থাকতে হবে।"
                            }
                        </li>
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                                {translate ?
                                    "4"
                                    :
                                    "৪"
                                }
                            </span>
                            {translate ?
                                "Product must be returned in original and exact manufacturer's packaging/box. If the product is excess  Deer perfume  Delivery is done by packaging ,  Then it must be returned in the same condition and attach the return shipping label/ clearly write your order number and return tracking number on the outside of the package. Do not put tape or stickers on the manufacturer's box."
                                :
                                "পণ্যটি অবশ্যই অরিজিনাল এবং অবিকল প্রস্তুতকারকের প্যাকেজিং/বক্সে রিটার্ন করতে হবে। যদি পণ্যটি অতিরিক্ত ডিয়ার পারফিউম প্যাকেজিংয়ের মাধ্যমে ডেলিভারি করা হয়, তাহলে সেটিকে অবশ্যই একই অবস্থায় ফেরত দিতে হবে এবং রিটার্ন শিপিং লেবেল সংযুক্ত করতে হবে/ প্যাকেজের বাহিরে পরিষ্কারভাবে আপনার অর্ডার নম্বর এবং রিটার্ন ট্র্যাকিং নম্বর লিখুন। প্রস্তুতকারকের বাক্সে টেপ বা স্টিকার লাগাবেন না।"
                            }
                        </li>
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                                {translate ?
                                    "5"
                                    :
                                    "৫"
                                }
                            </span>
                            {translate ?
                                "In case of Advance (Development/Rocket) payment , if the product is not in stock or the buyer is not willing to take it , the order will be canceled and the refund will be made to the number from which the advance payment was made."
                                :
                                "অ্যাডভান্স (বিকাশ/রকেট) পেমেন্ট এর ক্ষেত্রে ,পণ্য স্টকে না থাকলে অথবা ক্রেতা নিতে ইচ্ছুক না হলে, অর্ডার ক্যানসেল করে যে নাম্বার থেকে অ্যাডভান্স পেমেন্ট করা হয়েছে , সেই নাম্বারেই রিফান্ড করা হবে।"
                            }
                        </li>
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>

                                {translate ?
                                    "6"
                                    :
                                    "৬"
                                }
                            </span>
                            {translate ?
                                "You are our product  near  At the time of return ,  Collect the return acknowledgment form and fill it yourself. One copy will be kept by you and one copy will be kept by us for our use."
                                :
                                "আপনি আপনার পণ্যটি আমাদের কাছে রিটার্ন করার সময়ে, রিটার্ন একনলেজমেন্ট ফরমটি কালেক্ট করবেন এবং নিজে তা পূরণ করবেন। এক কপি আপনি নিজের কাছে রাখবেন এবং এক কপি আমাদের ব্যবহারের জন্য আমরা সংরক্ষন করে থাকি।"
                            }
                        </li>
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                                {translate ?
                                    "7"
                                    :
                                    "৭"
                                }
                            </span>
                            {translate ?
                                "The product must reach our office within 7 days of receipt."
                                :
                                "পণ্যটি গ্রহণ করার 7 দিনের মধ্যে আমাদের অফিসে পৌছাতে হবে।"
                            }
                        </li>
                    </ol>
                </ul>


                <div className="p-3 ">
                    <p className="">
                        <span className="font-semibold">

                            {translate ?
                                "Note:"
                                :
                                "বিঃদ্রঃ"
                            }
                        </span>
                        {translate ?
                            "Product must have original tag ,  User Manual ,  warranty card ,  free  gift  and accessories must be included."
                            :
                            " পণ্যটিতে অবশ্যই অরিজিনাল ট্যাগ, ব্যবহারকারীর ম্যানুয়াল, ওয়ারেন্টি কার্ড, ফ্রি গিফট এবং আনুষাঙ্গিকগুলো অন্তর্ভুক্ত থাকতে হবে।"
                        }
                    </p>
                </div>

                <div className="p-3 bg-gray-50">
                    <p className="">
                        <span className="font-semibold">
                            {translate ?
                                "B. Dr:"
                                :
                                "বিঃদ্রঃ"
                            }
                        </span>
                        {translate ?
                            "Our complaints team will call you for any complaints related to products and services. For this we would like to keep you active on the phone until your complaint is resolved. If the number given in your contact is not active, an alternate number must be active. For refund you need to tell us the method of refund. We are your kind of cooperation  15  If we do not receive a phone call or email within one business day, we will consider your complaint resolved.                                "
                            :
                            "পণ্য ও সার্ভিস সম্পর্কিত কোনো অভিযোগের জন্য আমাদের কমপ্লেইন্ট টীম আপনাকে ফোন করবেন। এ জন্য আপনার অভিযোগটি সমাধান না হওয়া পর্যন্ত আপনাকে আমরা ফোনে সক্রিয় পেতে চাই। আপনার যোগাযোগে দেওয়া নম্বরটি সক্রিয় না থাকলে বিকল্প কোনো নম্বর সক্রিয় থাকতে হবে। রিফান্ডের জন্য আপনাকে টাকাটি ফেরতের মাধ্যম আমাদের জানাতে হবে। আমরা আপনার কোনো প্রকার সহযোগিতা ১৫ কার্যদিবসের মধ্যে ফোনে অথবা ইমেইলে না পেলে আপনার অভিযোগটি নিস্পত্তি বলে মনে করবো।"
                        }
                    </p>
                </div>

                <div className="p-3 bg-gray-50">
                    <p className="">
                        <span className="font-semibold">

                            {translate ?
                                "Note:"
                                :
                                "দ্রষ্টব্য"
                            }
                        </span>
                    </p>

                    <ul className="pt-3">
                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                                {translate ?
                                    "1"
                                    :
                                    "১"
                                }
                            </span>
                            {translate ?
                                "Product orders will be delivered subject to stock availability. Product delivery may take longer due to natural or unavoidable reasons.                                    "
                                :
                                "প্রোডাক্টের অর্ডার স্টক থাকা সাপেক্ষে ডেলিভারি করা হবে। প্রাকৃতিক বা অনিবার্য কারনে পন্যের ডেলিভারিতে বেশী সময় লাগতে পারে।"
                            }
                        </li>

                        <li className="text-body-color mb-4 flex text-base">
                            <span className="relative z-10 mr-2 flex h-6 w-full max-w-[24px] items-center justify-center rounded text-base text-gray-900 font-semibold">
                                <span className="bg-white  border-2 border-bnd-1 absolute top-0 left-0 z-[-1] h-full w-full -rotate-45 rounded"></span>
                                {translate ?
                                    "2"
                                    :
                                    "২"
                                }
                            </span>
                            {translate ?
                                "Dear reserves the right to cancel your order at any time due to unavoidable reasons even after order confirmation. In this case, if the advance price is paid, the necessary information for refund (Bikash No./Rocket No./Card No. etc.) and if you do not accept it after giving the courier for product delivery, maximum 7 days after the return of the product from the said courier to Deer in the case of Bikash and online card. In this case money will be refunded within 10 days.                                    "
                                :
                                "অর্ডার কনফার্মেশনের পরেও অনিবার্য কারনবশত যেকোনো সময়ে ডিয়ার আপনার অর্ডার বাতিল করার ক্ষমতা রাখে। এক্ষেত্রে অগ্রিম মুল্য প্রদান করা হলে রিফান্ডের প্রয়োজনীয় তথ্য (বিকাশ নং/রকেট নং/কার্ড নং ও অন্যান্য) এবং প্রোডাক্ট ডেলিভারির জন্য কুরিয়ার দেয়ার পর আপনি গ্রহণ না করলে উক্ত কুরিয়ার থেকে প্রোডাক্টটি ডিয়ারে ফেরত আসার পর বিকাশ এর ক্ষেত্রে সর্বোচ্চ ৭ দিন এবং অনলাইন কার্ড এর ক্ষেত্রে ১০ দিনের মধ্যে টাকা ফেরত দেয়া হবে।"
                            }
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ReturnsAndRefunds;